export default __webpack_public_path__ + "static/logo@white-d2452419fecfb1fd5b530f7e5e30f9ed.svg";